import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mr1001',
    ecrans: ['00-2'],
    params: ['id', 'eclcleint', 'flgselmul', '?numcol', '?trncleint']
});
